module.exports = __webpack_public_path__ + "static/vision-2ac65ffbe066209e72387fdaee9253c4.png";